import { EntryCollection } from 'contentful';

import sanitizeLinks from './sanitizeLinks';
import fetchShopifyProducts from './fetchShopifyProducts';
import customizeVariantImages from './customizeVariantImages';

export default async function middleware<T extends object>(
  entries: EntryCollection<T>,
) {
  entries = sanitizeLinks(entries);
  entries = await fetchShopifyProducts(entries);
  entries = await customizeVariantImages(entries);

  return entries;
}
